export const administrationMessagesTranslation = {

  // section title
  manage_messages: 8457,

  no_access_to_message_administration: 8479,

  // buttons
  add_new: 6943,
  add_message: 8458,
  update_message: 8459,
  cancel: 3273,

  // search section
  search: 7345,
  search_hits: 7474,
  search_no_hits: 8482,

  // list
  show_inactive_messages: 8460,

  // list item
  show_less: 8481,
  show_more: 8480,

  // list menu
  open_message: 8461,
  delete_message: 8462,
  deactivate_message: 8463,
  publish_message: 8464,

  // list toasts
  message_published: 8516,
  message_deactivated: 8517,

  // item
  new_message: 8465,
  active: 8466,
  inactive: 8467,
  message: 3631,
  copy_message_to_all: 8468,
  message_copied_to_all: 8513,
  subject: 4008,
  copy_subject_to_all: 8469,
  subject_copied_to_all: 8512,
  translations_header: 8364,
  show_translations: 8393,

  // validation errors
  must_be_filled_out: 5949,

  // overlay
  saving_message: 8470,
  deleting_message: 8471,

  // notifications
  message_created: 8472,
  message_updated: 8473,
  message_deleted: 8474,
  message_validation_error: 8206,

  // prompt publish now
  publish_now_or_later: 8475,
  publish_now: 8476,
  publish_later: 8477,

  // prompt delete
  delete_message_confirm: 8478,

  // prompt cancel
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966
};

export type AdministrationMessagesTranslation = {
  readonly [T in keyof typeof administrationMessagesTranslation]: string
};

export const defaultMaxResults = 50;

export const maxLengthSubject = 254;
export const maxLengthMessage = 4000;
